module.exports = __webpack_public_path__ + "static/Dark-Stores-3e8a9f6410441a48b28560bd4cd5f0af.jpg";